import React, { useState } from "react";
import { X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useGenesis } from "@/hooks/useGenesis";
import { GenesisToken } from "@/components/genesis/GenesisToken";
import { StatusChip, Countdown, ExploreButton, BuyButton } from "@/components/genesis/GenesisBits";

const key = (uid) => `genesis_banner_dismissed:${uid}`;

// Compact For You banner. Dismissal is remembered per account on this device; hidden for everyone once the sale ended.
export function GenesisBanner() {
  const { user } = useAuth();
  const { data, status, countdown } = useGenesis();
  const [dismissed, setDismissed] = useState(() => { try { return !!localStorage.getItem(key(user?.user_id)); } catch { return false; } });
  if (!data || dismissed || !data.show_banner) return null;
  const dismiss = () => { setDismissed(true); try { localStorage.setItem(key(user?.user_id), "1"); } catch {} };
  const buy = data.purchase_link_enabled && status !== "ended";
  return (
    <div data-testid="genesis-banner" className="mx-auto mb-3 max-w-[600px] px-3 md:px-5 animate-[fadeIn_.4s_ease]">
      <div className="relative flex items-center gap-3 overflow-hidden rounded-2xl border border-am-border-strong bg-am-surface px-4 py-3">
        <span className="absolute inset-y-0 left-0 w-1 aura-gradient" />
        <div className="pointer-events-none absolute -left-10 -top-10 h-32 w-32 rounded-full aura-radial opacity-20 blur-2xl" />
        <GenesisToken size={44} parallax={false} className="shrink-0" />
        <div className="min-w-0 flex-1">
          <div className="flex flex-wrap items-center gap-2"><span className="font-display text-sm font-extrabold tracking-wide text-white">AURAMAX GENESIS</span><StatusChip status={status} /></div>
          <p className="mt-0.5 text-xs text-am-text2">The next chapter of AuraMax begins on Solana.</p>
          <div className="mt-1"><Countdown countdown={countdown} status={status} compact /></div>
          <div className="mt-2 flex flex-wrap items-center gap-2">
            <BuyButton data={data} status={status} size="sm" testid="genesis-banner-official-link" surface="banner" />
            <ExploreButton className="px-3 py-1.5 text-xs" testid="genesis-banner-explore" secondary={buy} />
          </div>
        </div>
        <button onClick={dismiss} aria-label="Dismiss" data-testid="genesis-banner-dismiss" className="grid h-7 w-7 shrink-0 place-items-center self-start rounded-full text-am-text2 hover:bg-white/10 hover:text-white"><X className="h-4 w-4" /></button>
      </div>
    </div>
  );
}
